import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { cooldownMs: { type: Number, default: 3000 } };

  connect() {
    this.cooldownActive = false;
  }

  trigger(event) {
    event.preventDefault();
    if (this.cooldownActive) return;

    this.cooldownActive = true;
    const original = this.element.innerHTML;
    this.element.setAttribute('disabled', 'disabled');
    this.element.classList.add('disabled');
    this.element.innerHTML = '<span class="spinner-border spinner-border-sm mr-2"></span>Memuat ulang...';

    // Reload immediately, but lock the button for the full cooldown so a fast
    // back/forward navigation can't re-fire it.
    setTimeout(() => window.location.reload(), 200);

    setTimeout(() => {
      this.cooldownActive = false;
      this.element.removeAttribute('disabled');
      this.element.classList.remove('disabled');
      this.element.innerHTML = original;
    }, this.cooldownMsValue);
  }
}
